// extracted by mini-css-extract-plugin
export default {"container":"chatMessage_container__UjLyC","chatBox":"chatMessage_chatBox__HDtnI"};